import { styled } from 'styled-components';
import { IconCalendarEvent } from '@tabler/icons-react';

export const StyledCalendarEventIcon = styled(IconCalendarEvent)`
    height: 20px;
    width: 20px;
    color: ${({ theme }) => theme.colors.grayscale.gray7};
`;
